import React from 'react';

import { Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import action_library_messages from 'messages/action_library_messages';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8, 2),
    textAlign: 'center',
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  description: {
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

type Props = {
  onResetFilters: () => void;
};

const EmptyState: React.FC<Props> = ({ onResetFilters }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Typography className={styles.title} variant='h5'>
        {t(action_library_messages.empty_state.title)}
      </Typography>
      <Typography className={styles.description} variant='body1'>
        {t(action_library_messages.empty_state.description)}
      </Typography>
      <Button className={styles.button} color='primary' onClick={onResetFilters} variant='contained'>
        {t(action_library_messages.empty_state.reset_filters)}
      </Button>
    </div>
  );
};

export default EmptyState;
